var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/BtnClose/BtnClose.jinja"] = require( "front/components/BtnClose/BtnClose.jinja" );
dependencies["front/components/BtnSide/BtnSide.jinja"] = require( "front/components/BtnSide/BtnSide.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectSide.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/BtnClose/BtnClose.jinja", false, "ProjectSide.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("BtnClose", t_1);
var macro_t_4 = runtime.makeMacro(
["projects"], 
[], 
function (l_projects, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("projects", l_projects);
var t_5 = "";t_5 += "<div class=\"ProjectSide\">\n        <div class=\"ProjectSide-listContainer\">\n            <ul class=\"ProjectSide-list\">\n                ";
frame = frame.push();
var t_8 = l_projects;
if(t_8) {var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("p", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                    <li class=\"ProjectSide-item\">\n                        <a class=\"ProjectSide-link\" href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"url"), env.opts.autoescape);
t_5 += "\" data-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"id"), env.opts.autoescape);
t_5 += "\">";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"title")), env.opts.autoescape);
t_5 += "</a>\n                    </li>\n                ";
;
}
}
frame = frame.pop();
t_5 += "\n            </ul>\n        </div>\n\n        <div class=\"ProjectSide-preview u-Cover\"></div>\n\n        ";
t_5 += runtime.suppressValue((lineno = 16, colno = 31, runtime.callWrap(runtime.memberLookup((t_1),"BtnClose"), "BtnClose[\"BtnClose\"]", context, [runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_5 += "\n\n        <div class=\"ProjectSide-btnSide\">\n            ";
env.getTemplate("front/components/BtnSide/BtnSide.jinja", false, "ProjectSide.jinja", function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_5 += t_13
t_5 += "\n        </div>\n    </div>\n    ";
t_5 += runtime.suppressValue((lineno = 22, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
})});
frame = frame.pop();
return new runtime.SafeString(t_5);
});
context.addExport("ProjectSide");
context.setVariable("ProjectSide", macro_t_4);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ProjectSide.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProjectSide/ProjectSide.jinja
// module id = 75
// module chunks = 0